// menu: 0=갯벌, 1=해초대, 2=염습지
export const getYearRange = (menu) => {
    switch (menu) {
        case 0:
            return { minYear: 1990, maxYear: 2018, defaultYear: 2018, areaChangeFrom: 1990 };
        case 1:
            return { minYear: 2016, maxYear: 2024, defaultYear: 2024, areaChangeFrom: 2016 };
        case 2:
            return { minYear: 1990, maxYear: 2024, defaultYear: 2024, areaChangeFrom: 1990 };
        default:
            return { minYear: 1990, maxYear: 2018, defaultYear: 2018, areaChangeFrom: 1990 };
    }
};

export const toYearOption = (year) => ({ value: year, label: `${year}년` });

export const getDefaultYearOption = (menu) => toYearOption(getYearRange(menu).defaultYear);

export const getAreaChangeFromOption = (menu) => toYearOption(getYearRange(menu).areaChangeFrom);

export const getMaxYearOption = (menu) => toYearOption(getYearRange(menu).maxYear);

export const buildYearList = (menu) => {
    const { minYear, maxYear } = getYearRange(menu);
    const years = [];
    for (let i = minYear; i <= maxYear; i++) {
        years.push(toYearOption(i));
    }
    return years;
};
